import { defineComponent as L, computed as m, createElementBlock as d, openBlock as n, normalizeClass as E, unref as l, createBlock as i, createCommentVNode as v, Fragment as f, renderList as M } from "vue";
import { DocumentClasses as j } from "@scalar-org/css";
import { useColorMode as V } from "@scalar/use-hooks/useColorMode";
import { useMediaQuery as D } from "@vueuse/core";
import { useRoute as S } from "vue-router";
import _ from "./HeaderItemGroup.vue.js";
import H from "./HeaderItemLink.vue.js";
import N from "./HeaderItemMeta.vue.js";
import O from "./HeaderItemSpacer.vue.js";
import $ from "./HeaderItemTab.vue.js";
import w from "./HeaderItemVersionSelect.vue.js";
const J = /* @__PURE__ */ L({
  __name: "DocumentHeader",
  props: {
    project: {},
    versions: {},
    activeVersion: {},
    activeUids: {},
    activeGuide: {},
    headerLinks: {},
    isEditable: { type: Boolean },
    resolveInternalLinks: { type: Function }
  },
  emits: ["selectVersion", "navigate", "setSidebar", "toggleShow", "editOpenAPIDocument"],
  setup(g, { emit: k }) {
    const t = g, a = k, p = S(), { isDarkMode: y } = V(), b = m(() => y.value ? t.project.logo.darkMode : t.project.logo.lightMode), s = D("(max-width: 1000px)"), I = m(() => {
      const e = [...t.headerLinks];
      return s.value ? e.sort((o) => o.type === "version-selector" ? -1 : 1).filter((o) => o.type !== "spacer") : e;
    });
    function u(e, o) {
      a("navigate", o, e), s.value && a("setSidebar", !1);
    }
    function h(e, o) {
      a("toggleShow", e, o);
    }
    function c(e) {
      var o;
      return (o = t.activeUids) != null && o.includes(e.uid) || e.uid === p.name || e.uid === t.activeGuide || Object.values(p.params).includes(e.uid) ? !0 : e.type === "group" ? e.children.some((r) => c(r)) : !1;
    }
    return (e, o) => (n(), d("header", {
      class: E(["header", l(j).Header])
    }, [
      l(s) ? v("", !0) : (n(), i(N, {
        key: 0,
        logo: b.value,
        primaryVersionUid: e.project.activeVersionId,
        projectName: e.project.name
      }, null, 8, ["logo", "primaryVersionUid", "projectName"])),
      (n(!0), d(f, null, M(I.value, (r) => (n(), d(f, {
        key: r.uid
      }, [
        r.type === "group" ? (n(), i(_, {
          key: 0,
          group: r,
          isEditable: !!e.isEditable,
          isMobile: l(s),
          linkIsActive: c,
          resolveInternalLinks: e.resolveInternalLinks,
          onNavigate: u
        }, null, 8, ["group", "isEditable", "isMobile", "resolveInternalLinks"])) : r.type === "guide" || r.type === "reference" ? (n(), i($, {
          key: 1,
          isEditable: !!e.isEditable,
          isMobile: l(s),
          linkIsActive: c,
          resolveInternalLinks: e.resolveInternalLinks,
          tab: r,
          onEditOpenAPIDocument: (A) => a("editOpenAPIDocument", r.uid),
          onNavigate: u,
          onToggleShow: h
        }, null, 8, ["isEditable", "isMobile", "resolveInternalLinks", "tab", "onEditOpenAPIDocument"])) : r.type === "link" ? (n(), i(H, {
          key: 2,
          link: r
        }, null, 8, ["link"])) : r.type === "spacer" ? (n(), i(O, { key: 3 })) : r.type === "version-selector" && Object.keys(e.versions).length > 1 ? (n(), i(w, {
          key: 4,
          activeVersion: e.activeVersion,
          versions: e.versions,
          onNavigate: u
        }, null, 8, ["activeVersion", "versions"])) : v("", !0)
      ], 64))), 128))
    ], 2));
  }
});
export {
  J as default
};
